module.exports = __webpack_public_path__ + "static/media/pay4.4587872d.png";